// Inlined port of the `is-base64` npm package (MIT, miguelmota), rewritten in TypeScript.
// Original: https://github.com/miguelmota/is-base64/blob/master/is-base64.js

type IsBase64Options = {
	allowEmpty?: boolean;
	mimeRequired?: boolean;
	allowMime?: boolean;
	paddingRequired?: boolean;
};

const isBase64 = (value: unknown, opts: IsBase64Options = {}): boolean => {
	if (typeof value !== 'string') return false;
	if (opts.allowEmpty === false && value === '') return false;

	let regex = '(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}==|[A-Za-z0-9+\\/]{3}=)?';
	const mimeRegex = '(data:\\w+\\/[a-zA-Z\\+\\-\\.]+;base64,)';

	if (opts.mimeRequired === true) {
		regex = mimeRegex + regex;
	} else if (opts.allowMime === true) {
		regex = mimeRegex + '?' + regex;
	}

	if (opts.paddingRequired === false) {
		regex = '(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}(==)?|[A-Za-z0-9+\\/]{3}=?)?';
	}

	return new RegExp('^' + regex + '$', 'gi').test(value);
};

export default isBase64;
